/**
 * Use fallback of document.execCommand for browsers that refuse to work with clipboard.writeText
 * E.g. Opera for Android doesn't give permissions to use clipboard.writeText for some reason.
 */
const copyToClipboard = async (text: string) => {
  try {
    return await navigator.clipboard.writeText(text);
  } catch {
    const tempInput = document.createElement('input');
    tempInput.setAttribute('value', text);
    document.body.appendChild(tempInput);
    tempInput.select();
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const copyResult = document.execCommand('copy');
    document.body.removeChild(tempInput);
    if (!copyResult) {
      // throw this to catch it somewhere
      throw new Error('Failed to copy to clipboard using document.execCommand');
    }
  }
};

export default copyToClipboard;
